import { uiNotify } from "../../actions";


export const CATALOGS_LOADED = "CATALOGS_LOADED";

export const getCatalogos = () => (dispatch) => {

  const language = window.ferrero ? window.ferrero.locale : "es_ES";
  
  dispatch(uiNotify({ text: "Loading data..." }));

  const ES_URL = `/api/es/catalog`;
  const PT_URL = `/api/pt/catalog`;

  return fetch(language === "es_ES" ? ES_URL : PT_URL)
    .then((res) => res.json())

    .then((data) => {
      dispatch(uiNotify({ text: "Catalog data loaded" }));

      return dispatch({
        type: CATALOGS_LOADED,
        payload: {
          data: data,
        },
      });
    })

    .catch((error) => {
      console.log(error);
      dispatch(
        uiNotify({
          text: error,
        })
      );
      return dispatch(error);
    });
};



export const CATALOG_CREATED = "CATALOG_CREATED";

export const createCatalog = (data) => (dispatch) => {

  const language = window.ferrero ? window.ferrero.locale : "es_ES";
  
  dispatch(uiNotify({ text: "Loading data..." }));

  const ES_URL = `/api/es/catalog/new`;
  const PT_URL = `/api/pt/catalog/new`;

  return fetch(language === "es_ES" ? ES_URL : PT_URL, {
    method: "POST",
    headers: {
      Accept: "application/json;odata=verbose",
      'Content-Type': 'application/json'

    },
    body: JSON.stringify(data)
  })
    .then((res) => res.json())

    .then((data) => {
      dispatch(uiNotify({ text: "Catalog data created" }));

      return dispatch({
        type: CATALOG_CREATED,
        payload: {
          data: data.catalogs,
        },
      });
    })

    .catch((error) => {
      console.log(error);
      dispatch(
        uiNotify({
          text: error,
        })
      );
      return dispatch(error);
    });
};


export const CATALOG_DELETE = "CATALOG_DELETE";


export const deleteCatalogo = (catalogId) => (dispatch) => {

  const language = window.ferrero ? window.ferrero.locale : "es_ES";
  
  dispatch(uiNotify({ text: "Loading data..." }));

  const ES_URL = `/api/es/catalog/${catalogId}`;
  const PT_URL = `/api/pt/catalog/${catalogId}`;

  return fetch(language === "es_ES" ? ES_URL : PT_URL, {
    method: "DELETE",
    headers: {
      Accept: "application/json;odata=verbose",
      'Content-Type': 'application/json'

    },
  })
    .then((res) => res.json())

    .then((data) => {
      dispatch(uiNotify({ text: "Catalog data loaded" }));

      return dispatch({
        type: CATALOG_DELETE,
        payload: {
          data: data.catalogs,
        },
      });
    })

    .catch((error) => {
      console.log(error);
      dispatch(
        uiNotify({
          text: error,
        })
      );
      return dispatch(error);
    });
};



